import React, { Component } from 'react';
import styled from 'styled-components';
import { List, Alert, Button, Tooltip, Popconfirm, message, Tabs, Select, Checkbox, Row, Col, Menu, Dropdown } from 'antd';
import { withStateHandlers } from 'recompose';
import { asyncConnect, toSuccess } from 'react-async-client';
import { all, append, contains, remove, find, findIndex, includes, propEq, pathOr, any, filter, pick, prop, without } from 'ramda';
import { takeEvery } from 'redux-saga/effects';
import { Field } from 'react-final-form';
import { UserOutlined, MailOutlined, PhoneOutlined, PlusOutlined, DeleteOutlined, DownOutlined} from '@ant-design/icons';

import Modal from './Modal';
import { getUser, getCompanyEmployees, deleteSurveyRespondent, postSurveyRespondent, postSurveyRespondents } from '../../actions/asyncActions';
import { PUT_SURVEY_RESPONDENT, POST_SURVEY_RESPONDENT } from '../../constants/actionTypes';
import { ADMIN_MODERATOR } from '../../constants/roles';
import InputSearch from '../forms/formComponents/InputSearch';
import CompanyRespondentForm from '../forms/CompanyRespondentForm';
import withFormWrapper from '../hocs/withFormWrapper';

const ListHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .ant-form-item {
        margin: 0;
        width: 70%;
    }
    .dropdown-link {
        color: #F54D2E;
        .dropdown-link-text {
            display: inline-block;
            border-bottom: 1px dashed #F54D2E;
        }
    }
`;
const TabsHeader = styled.div`
    padding: 12px 15px 10px;
    background: #fafafa;
    border-bottom: 1px solid #f0f0f0;

    form h3:first-child {
        margin: -16px -10px 15px;
    }
    form h3 {
        margin-left: -10px;
        margin-right: -10px;
    }
`;

const Lists = styled.div`
    margin: 15px 0;
    display: flex;
`;

const ListWrapper = styled.div`
    width: 50%;
    margin-right: ${({ left }) => left ? 5 : 0}px;
    margin-left: ${({ left }) => left ? 0 : 5}px;
    .ant-list-header {
        font-size: 1rem;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
    }
    .ant-list .ant-list-header{
        padding: 10px 15px;
    }
`;

const TabsWrapper = styled(ListWrapper)`
    border: 1px solid #d9d9d9;
    border-radius: 0px;
    .ant-list-header {
        background: none;
        .ant-select {
            width: 100%;
            .ant-select-selection-selected-value > div {
                padding-left: 0;
            }
        }
    }
    .ant-list.ant-list-split .ant-list-header {
        padding-top: 0;
    }
    .ant-list {
        border: none;
    }
    .ant-tabs-tabpane form h3:first-child {
        margin: 2px 0px 15px;
    }
    .ant-tabs-tabpane form {
        padding: 10px 15px;
    }
    .ant-tabs-tabpane form h3 {
        margin: 5px 0 15px;
        padding: 0px;
        background-color: transparent;
    }
    .table-footer {
        padding: 15px;
        border: 1px solid #f0f0f0;
        border-top: 0;
        .ant-btn {
            margin-right: 6px;
        }
    }
    .ant-btn-icon-only {
        line-height: 1;
    }
    form .ant-form-item,
    button[type=submit] {
        margin: 0 12px 12px;
    }
    .ant-form {
        .ant-form-item {
            margin-left: 0;
        }
        .ant-form-item-label {
            text-align: left;
            small {
                display: block;
            }
            label {
                white-space: break-spaces;
                height: auto
            }
        }
        .ant-btn.ant-btn-primary {
            margin-left: 0;
        }
    }
`;

const ListItem = styled(List.Item)`
    justify-content: space-between;
`;

const TestSelect = styled.div`
    .ant-select {
        width: 100%;
        margin-top: 15px;
    }
`;

const Filters = styled.div`
    background: #fff;
    margin: -15px;
    padding: 15px;
    margin-top: 0px;
    border-bottom: 1px solid #f0f0f0;
    .ant-form-item {
        margin-bottom: 0;
    }
`;

class AddRespondentModal extends Component {
    deleteRespondent = ({ id, survey, company }) => {
        this.props.deleteSurveyRespondent.dispatch({
            id,
            survey,
            company,
        });
    }

    addRespondent = employee => {
        const { params: { item }, postSurveyRespondent } = this.props;

        postSurveyRespondent.dispatch({
            ...pick(['firstName', 'lastName', 'middleName', 'email', 'phone', 'company'], employee),
            employee: employee.id,
            survey: item.id,
            status: 'created'
        });
    }

    onCheck = id => this.props.setSelected(includes(id, this.props.selected) ? without([id], this.props.selected) : append(id, this.props.selected));

    checkAll = items => {
        this.props.setSelected(this.props.selected.length === items.length ? [] : items.map(prop('id')));
    }

    addSelected = () => {
        const { params: { item }, postSurveyRespondents, getCompanyEmployees, selected } = this.props;

        postSurveyRespondents.dispatch({
            items: selected.map(id => {
                const respondent = find(propEq('id', id), pathOr([], ['data', 'items'], getCompanyEmployees));

                return {
                    ...pick(['firstName', 'lastName', 'middleName', 'email', 'phone', 'company'], respondent),
                    employee: respondent.id,
                    survey: item.id,
                    status: 'created'
                };
            })
        });
    }

    renderRow = (item, respondent) => {
        return <ListItem>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                { !respondent &&
                    <Checkbox style={{ marginRight: 20 }} checked={includes(item.id, this.props.selected)} onChange={() => this.onCheck(item.id)} />
                }
                <div>
                    <div style={{ color: '#000' }}>
                        { item.position &&
                            <Tooltip title={item.position}>
                                <UserOutlined style={{ marginRight: 5 }} />
                            </Tooltip>
                        }
                        { item.lastName } { item.firstName } { item.middleName || '' }
                    </div>
                    <div><MailOutlined /> { item.email }</div>
                    { item.phone && <div><PhoneOutlined /> { item.phone }</div> }
                </div>
            </div>
            { respondent ?
                <Popconfirm
                    title='Вы уверены, что хотите удалить респондента?'
                    okText='Да'
                    cancelText='Нет'
                    onConfirm={() => this.deleteRespondent(item)}>
                    <Button icon={<DeleteOutlined />} type='danger' />
                </Popconfirm> :
                <Button
                    icon={<PlusOutlined />}
                    onClick={() => this.addRespondent(item)} />
            }
        </ListItem>;
    }

    onSubmitSuccess = () => {
        this.form.reset();
    }

    render() {
        const {
            modal,
            params: { item, groups, company },
            respondents,
            postSurveyRespondent,
            getCompanyEmployees,
            isAdmin,
            group,
            fromRespondents,
            setFromRespondents,
            selected,
            setName,
            setGroup
        } = this.props;
        const employees = filter(item => !any(propEq('employee', item.id), respondents), pathOr([], ['data', 'items'], getCompanyEmployees));
        const unselectedRespondents = pathOr([], ['data', 'items'], getCompanyEmployees);
        const unselectedItems = fromRespondents ? unselectedRespondents : [];
        const menu = <Menu>
            <Menu.Item key='respondents' onClick={() => setFromRespondents(true)}>из базы сотрудников</Menu.Item>
            <Menu.Item key='new' onClick={() => setFromRespondents(false)}>нового респондента</Menu.Item>
        </Menu>;

        return <Modal
            {...modal}
            title='Добавить респондента'
            footer={null}>
            <Alert type='info' message={`На этом шаге определите респондентов, участвующих в процедуре опроса. Это могут быть кандидаты и сотрудники компании. Вы также может выбрать сотрудников из ранее внесенного списка сотрудников, а также можете добавить респондентов в список сотрудников. Для этого вам потребуется создать должность в разделе ${isAdmin ? 'Компании' : 'Компания'}.`} />
            { groups.length > 1 &&
                <TestSelect>
                    <Select
                        placeholder='Группа'
                        value={group}
                        onChange={setGroup}>
                        { groups.map(test =>
                            <Select.Option key={test.id} value={test.id}>{ test.value }</Select.Option>
                        )}
                    </Select>
                </TestSelect>
            }
            <Lists>
                <ListWrapper left>
                    <List
                        header={<ListHeader>Респонденты</ListHeader>}
                        dataSource={respondents}
                        renderItem={item => this.renderRow(item, true)}
                        bordered />
                </ListWrapper>
                <TabsWrapper>
                    <TabsHeader>
                        <ListHeader>
                            <div>
                                { fromRespondents &&
                                    <Checkbox style={{ marginRight: 8 }} checked={fromRespondents && all(({ id }) => includes(id, selected), unselectedItems)} onChange={() => this.checkAll(unselectedItems)} />
                                }
                                <strong>Добавить <Dropdown overlay={menu} trigger={['click']}>
                                        {/* eslint-disable-next-line */}
                                        <a className='dropdown-link' onClick={e => e.preventDefault()}>
                                            <span className='dropdown-link-text'>{ fromRespondents ? 'из базы сотрудников' : 'нового респондента' }</span> <DownOutlined />
                                        </a>
                                    </Dropdown>
                                </strong>
                            </div>
                        </ListHeader>
                    </TabsHeader>
                    <Tabs renderTabBar={() => null} activeKey={fromRespondents ? 'employees' : 'new'}>
                        <Tabs.TabPane tab='Новый респондент' key='new'>
                            <CompanyRespondentForm
                                getRef={node => this.form = node}
                                formAction={postSurveyRespondent}
                                onSubmitSuccess={this.onSubmitSuccess}
                                survey={item.id}
                                item={{
                                    company: company,
                                    survey: item.id,
                                    status: 'created',
                                    respondentFormFields: item.respondentFormFields
                                }}
                                showTestsField={false}
                            />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab='Сотрудники' key='employees'>
                            <List
                                header={
                                    <Filters>
                                        <Row gutter={6}>
                                            <Col xs={24}>
                                                <Field
                                                    name='name'
                                                    component={InputSearch}
                                                    placeholder='Поиск'
                                                    onChange={setName} />
                                            </Col>
                                        </Row>
                                    </Filters>
                                }
                                dataSource={employees}
                                renderItem={item => this.renderRow(item)}
                                loading={getCompanyEmployees.meta.pending}
                                bordered />
                            <div className='table-footer'>
                                <Button type='primary' disabled={!selected.length} onClick={() => this.addSelected()}>Добавить выбранных ({ selected.length })</Button>
                                {/* <Button>Добавить всех { fromRespondents ? 'респондентов' : 'сотрудников' } ({ unselectedItems.length })</Button> */}
                            </div>
                        </Tabs.TabPane>
                    </Tabs>
                </TabsWrapper>
            </Lists>
        </Modal>;
    }
}

const stateToProps = state => ({
    isAdmin: contains(getUser.selectData(state).role, ADMIN_MODERATOR),
});

export default withStateHandlers(({ params: { item }}) => ({
    name: null,
    selected: [],
    respondents: [],
    group: null,
    fromRespondents: true,
}), {
    addRespondent: ({ respondents }) => respondent => ({
        respondents: append(respondent, respondents)
    }),
    setRespondents: () => respondents => ({ respondents }),
    setName: () => name => ({ name, selected: [] }),
    setSelected: () => selected => ({ selected }),
    removeRespondent: ({ respondents }) => id => ({
        respondents: remove(findIndex(propEq('id', id), respondents), 1, respondents)
    }),
    setFromRespondents: () => fromRespondents => ({ fromRespondents, name: null, project: null, selected: [] }),
    setGroup: () => group => ({ group })
})(asyncConnect({
    deleteSurveyRespondent: deleteSurveyRespondent
        .withSuccessHandler(({ removeRespondent, deleteSurveyRespondent: { data: { id } }}) => {
            removeRespondent(id);
            message.success('Респондент успешно удален');
        })
        .withErrorHandler(() => message.error('Не удалось удалить респондента'))
        .withOptions({ resetOnUnmount: true }),
    postSurveyRespondent: postSurveyRespondent
        .withSuccessHandler(({ postSurveyRespondent: { data }, addRespondent }) => {
            addRespondent(data);
        })
        .withOptions({ resetOnUnmount: true }),
    postSurveyRespondents: postSurveyRespondents
        .withSuccessHandler(({ postSurveyRespondents: { data }, setRespondents, respondents }) => {
            setRespondents(respondents.concat(data));
        })
        .withOptions({ resetOnUnmount: true }),
    getCompanyEmployees: getCompanyEmployees
            .withPayload(({ params: { company }, name }) => ({
                company,
                limit: 0,
                q: {
                    text: name
                }
            }))
            .withSaga(function* (getProps) {
                yield takeEvery([toSuccess(POST_SURVEY_RESPONDENT), toSuccess(PUT_SURVEY_RESPONDENT)], function(action) {
                    const { getCompanyEmployees } = getProps();

                    if (action.payload.employee) {
                        getCompanyEmployees.refresh();
                    }
                })
            })
            .withOptions({ dispatchOnMount: true, resetOnUnmount: true, dispatchOnUpdate: true })
}, stateToProps)(withFormWrapper(AddRespondentModal)));
